import { 
    apiGetUserInfo,
    apiGetUserIdCard,
    baseDomain
} from "@/apis/api.js"; 


/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_user_info: 'userVerified/set_user_info',
    set_verified_alarm: 'userVerified/set_verified_alarm',
    set_verify_status: 'userVerified/set_verify_status',
    set_verify_user_id_card: 'userVerified/set_verify_user_id_card'
}

//未認證 1 
//資料未填2 
//資料已填但未上傳證件3
//審核中4
//正常5
//審查未通過6
//帳號停用7

const state = {
    userStatus: null,
    userState: localStorage.getItem('userState'),
    userDetail: null,
    verifyStatus: false,
    verifiedAlarm: false,
    userNickName: null,
    userUnpassReason: null,
    userAccount: null,
    userShot: null,
    userIdCard:{
        font: null,
        back: null
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_USER_STATUS: (state) => {
        return state.userStatus
    },
    GET_USER_DETAIL: (state) => {
        return state.userDetail
    },
    GET_USER_HAS_NICKNAME: (state) => {
        if(state.userNickName){
            return true
        }else{
            return false
        }
    },
    GET_USER_VERIFY_STATUS: (state) => {
        return state.verifyStatus
    },
    GET_USER_INFO: (state) => {
        return state.userDetail
    },
    GET_USER_UNPASS_REASON: (state) => {
        return state.userUnpassReason
    },
    GET_VERIFIED_ALARM_STATE: (state) => {
        return state.verifiedAlarm
    }
    ,
    GET_VERIFIED_USER_ACCOUNT: (state) => {
        return state.userAccount
    },
    GET_VERIFIED_USER_SHOT: (state) => {
        return state.userShot
    }
}

// actions 也是以 Object 形式建構。
const actions = {
    getUserStatus ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            apiGetUserInfo()
            .then(res => {
                console.log(res)
                if(res.data.status == "SUCCESS"){
                    if(res.data.result.user.status == 5){
                        localStorage.setItem('userState', true)
                        commit(types.set_verify_status, true)
                    }else{
                        localStorage.setItem('userState', false)
                        commit(types.set_verify_status, false)
                    }
                    commit(types.set_user_info, res.data.result)
                    resolve(res)
                }
                // commit(types.auth_success, token)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getUserIdCard ( {commit} , data) {
        return new Promise((resolve, reject) => {
            apiGetUserIdCard(data)
            .then(res => {
                if(res.status == 200){
                    resolve(res)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_user_info](state, data){
        // console.log(data)
        state.userAccount = data.user.account
        state.userStatus = data.user.status
        state.userUnpassReason = data.user.statusDesc
        if(data.userDetail){
            state.userDetail = data.userDetail
            state.userNickName = data.userDetail.nickName
        }
        if(data.userFile){
            data.userFile.map(item => {
                if(item.fileType == 1){
                    state.userShot = baseDomain + item.fileName
                }
            })
        }
    },
    [types.set_verified_alarm](state, data){
        state.verifiedAlarm = data
    },
    [types.set_verify_status](state, data){
        state.verifyStatus = data
    },
    [types.set_verify_user_id_card](state, data){
        state.verifyStatus = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/userVerified.js